import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { calcularDerivadosExperiencia } from "../domain";
import { listarExperiencias } from "../queries";
import { tocarAudio } from "../audio";
import type { ExperienciaMusical } from "../types";
import { ExperienciaFoto } from "../ui/ExperienciaFoto";

/**
 * P0.5 — kit rápido: atalho às experiências por efeito regulatório e favoritas.
 * "Preciso acalmar agora" em ≤2 toques. Tocar a linha abre o registro; o ▶ ouve
 * o áudio na hora (quando houver).
 */
export function KitRapido() {
  const nav = useNavigate();
  const experiencias = useLiveQuery(() => listarExperiencias()) ?? [];
  const momentos = useLiveQuery(() => db.momento.toArray()) ?? [];

  const ativas = experiencias.filter((e) => e.status !== "sensivel");
  const efeito = (e: ExperienciaMusical) =>
    calcularDerivadosExperiencia(e.id, momentos).efeito_regulatorio;

  const acalmar = ativas.filter((e) => ["acalma", "regula"].includes(efeito(e)));
  const ativar = ativas.filter((e) => efeito(e) === "ativa");
  const favoritas = ativas.filter((e) => e.status === "favorita");

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <h1 className="tela-titulo">kit rápido</h1>
      <p className="tela-sub">o que costuma funcionar, à mão. derivado dos momentos registrados.</p>

      <Grupo
        titulo="🌙 preciso acalmar agora"
        vazio="ainda sem experiências que tendem a acalmar — registre a regulação (antes/depois) pra descobrir."
        lista={acalmar}
        onAbrir={(id) => nav(`/compasso/registrar/${id}`)}
      />
      <Grupo
        titulo="⚡ preciso ativar agora"
        vazio="ainda sem experiências que tendem a ativar."
        lista={ativar}
        onAbrir={(id) => nav(`/compasso/registrar/${id}`)}
      />
      <Grupo
        titulo="★ favoritas"
        vazio="marque experiências como favoritas para vê-las aqui."
        lista={favoritas}
        onAbrir={(id) => nav(`/compasso/registrar/${id}`)}
      />
    </main>
  );
}

function Grupo({
  titulo,
  vazio,
  lista,
  onAbrir,
}: {
  titulo: string;
  vazio: string;
  lista: ExperienciaMusical[];
  onAbrir: (id: string) => void;
}) {
  return (
    <section className="secao">
      <h2 className="secao-titulo">{titulo}</h2>
      {lista.length === 0 ? (
        <div className="card" style={{ color: "var(--text-muted)" }}>
          {vazio}
        </div>
      ) : (
        lista.map((e) => (
          <div className="card linha-alimento" key={e.id}>
            <button
              className="linha-alimento crescer"
              style={{ background: "transparent", border: "none" }}
              onClick={() => onAbrir(e.id)}
            >
              <ExperienciaFoto midias={e.midias} nome={e.nome} tipo={e.tipo} />
              <div className="crescer">
                <div className="nome">{e.nome}</div>
              </div>
            </button>
            <button
              className="btn btn-fantasma"
              aria-label={`ouvir ${e.nome}`}
              onClick={() => void tocarAudio(e)}
            >
              ▶
            </button>
          </div>
        ))
      )}
    </section>
  );
}
